import ActionNames from '../action.names';

export const actions = {
  [ActionNames.Permissions.FetchPluginPermissions]: () => import('./plugin-permissions.json')
};
